import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import Scrollbar from "react-scrollbars-custom";
import { MaintenanceItemEmpty } from "../components/Empty";



const colorScale = [
  "#E4D354", // rgb(228, 211, 84)
  "#22B2D4", // rgb(34, 178, 212)
  "#28A745",
  "#566374",
  "#1976D2",
  "#DC3545",
  "#0A83A1",
  "#045266"
];

const MultiLinearProgress = ({ data }) => {
    if (!data || data.length === 0) {
        return <div
            style={{
                backgroundColor: "transparent",
                borderRadius: "8px",
                height: "100%",
            }}
        >
            <MaintenanceItemEmpty />
        </div>;
    }

    return (
        <Scrollbar style={{ height: "250px" }}>
            {data.map((item, index) => (
                <Box key={index} mb={2}>
                    <Box display="flex" justifyContent="space-between" mb={0.5}>
                        <Typography variant="body2" fontWeight={600}>
                            {item.itemName}
                        </Typography>
                        <Typography variant="body2">{item.usedCount}</Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={item.usedCountPercentage}
                        sx={{
                            height: 20,
                            borderRadius: 5,
                            backgroundColor: "#eee",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: colorScale[index % colorScale.length],
                            },
                        }}
                        aria-label={`Progress for ${item.itemName}`}
                    />
                </Box>
            ))}
        </Scrollbar>
    );
};

export default MultiLinearProgress;
